var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0L7.36953 1.37245C8.06 3.93687 10.0631 5.94 12.6276 6.63047L14 7L12.6276 7.36953C10.0631 8.06 8.06 10.0631 7.36953 12.6276L7 14L6.63047 12.6276C5.94 10.0631 3.93687 8.06 1.37245 7.36953L0 7L1.37245 6.63047C3.93687 5.94 5.94 3.93687 6.63047 1.37245L7 0Z",
    fill: "url(#paint0_linear_549_9983)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_549_9983",
    x1: -10.3617,
    y1: -3.20833,
    x2: -5.62375,
    y2: 15.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443013,
    stopColor: "#202261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#543C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#6939A2"
  })))));
};
export { SvgStar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcgMEw3LjM2OTUzIDEuMzcyNDVDOC4wNiAzLjkzNjg3IDEwLjA2MzEgNS45NCAxMi42Mjc2IDYuNjMwNDdMMTQgN0wxMi42Mjc2IDcuMzY5NTNDMTAuMDYzMSA4LjA2IDguMDYgMTAuMDYzMSA3LjM2OTUzIDEyLjYyNzZMNyAxNEw2LjYzMDQ3IDEyLjYyNzZDNS45NCAxMC4wNjMxIDMuOTM2ODcgOC4wNiAxLjM3MjQ1IDcuMzY5NTNMMCA3TDEuMzcyNDUgNi42MzA0N0MzLjkzNjg3IDUuOTQgNS45NCAzLjkzNjg3IDYuNjMwNDcgMS4zNzI0NUw3IDBaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfNTQ5Xzk5ODMpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNTQ5Xzk5ODMiIHgxPSItMTAuMzYxNyIgeTE9Ii0zLjIwODMzIiB4Mj0iLTUuNjIzNzUiIHkyPSIxNS4xNjIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzE0MTMzMyIvPgo8c3RvcCBvZmZzZXQ9IjAuNDQzMDEzIiBzdG9wLWNvbG9yPSIjMjAyMjYxIi8+CjxzdG9wIG9mZnNldD0iMC44MDIwODMiIHN0b3AtY29sb3I9IiM1NDNDOTciLz4KPHN0b3Agb2Zmc2V0PSIwLjk3Mzk1OCIgc3RvcC1jb2xvcj0iIzY5MzlBMiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";